import { standardTokenABI } from '@/utils/standardTokenABI'

// --------------------------------------------------------------------------
function _getTokenName (tokenContract) {
  return new Promise((resolve, reject) => {
    tokenContract.name((err, name) => {
      if (err) {
        // console.log(err)
        reject(err)
      }
      else {
        resolve(name)
      }
    })
  })
}

function _getTokenSymbol (tokenContract) {
  return new Promise((resolve, reject) => {
    tokenContract.symbol((err, symbol) => {
      if (err) {
        // console.log(err)
        reject(err)
      }
      else {
        resolve(symbol)
      }
    })
  })
}

function _getTokenDecimals (tokenContract) {
  return new Promise((resolve, reject) => {
    tokenContract.decimals((err, decimals) => {
      if (err) {
        // console.log(err)
        reject(err)
      }
      else {
        resolve(decimals.toNumber())
      }
    })
  })
}

export const searchTokenByAddress = (tokenAddress, ABI=standardTokenABI) =>  {
  // console.log('searchTokenByAddress')
  return new Promise((resolve, reject) => {
    if (window.web3) {
      tokenAddress = tokenAddress.toLowerCase()
      const tokenSearchResult = {
        address: tokenAddress,
        name: null,
        symbol: null,
        decimals: null
      }
      const tokenContract = window.web3.eth.contract(ABI).at(tokenAddress)
      // console.log(tokenContract)

      const tasks = []

      const getName = _getTokenName(tokenContract)
        .then( name => {
          if (name.startsWith('0x') || name.startsWith('0X')) {
            name = window.web3.toAscii(name).replace(/\0+$/,'')
            console.log('name', name + '|')
          }
          tokenSearchResult.name = name
        }, err => {
          console.log('getName Error for tokenAddress ' + tokenAddress + ': ' + err)
        })
      tasks.push(getName)

      const getSymbol = _getTokenSymbol(tokenContract)
        .then( symbol => {
          if (symbol.startsWith('0x') || symbol.startsWith('0X')) {
            symbol = window.web3.toAscii(symbol).replace(/\0+$/,'')
          }
          tokenSearchResult.symbol = symbol
        }, err => {
          console.log('getSymbol Error for tokenAddress ' + tokenAddress + ': ' + err)
        })
      tasks.push(getSymbol)

      const getDecimals = _getTokenDecimals(tokenContract)
        .then( decimals => {
          tokenSearchResult.decimals = decimals
        }, err => {
          console.log('getDecimals Error for tokenAddress ' + tokenAddress + ': ' + err)
        })
      tasks.push(getDecimals)

      Promise.all(tasks).then( () => {
        if (tokenSearchResult.name && tokenSearchResult.symbol && tokenSearchResult.decimals !== null) {
          resolve(tokenSearchResult)
        }
        else {
          resolve(null)
          // return reject('NOT found')
        }
      }, err => {
        console.log(err)
      })

    }
    else {
      console.log('No Web3')
      return reject('No Web3')
    }
  })

}
